/**
 * One "stamp ink" color per kid, cycling by `child.id` - not by list position, which
 * reshuffles every kid's color the moment someone reorders or a new child is added. Shared
 * across the dashboard cards, a child's own ledger header, and the kid-mode nav so the same
 * kid always reads as the same color everywhere.
 */
const STAMP_INKS = ['#b14a2d', '#2c6e8e', '#4b6b2f', '#7a3e74', '#9c6b1f']

export function kidAccent(childId: number): string {
  return STAMP_INKS[childId % STAMP_INKS.length]
}
